import React from "react";
import { DomainStepView } from "../../../../constants";
import DomainConnectInfo from "./DomainConnectInfo";

interface IDomainConnectViewProps {
  userDomain: string;
  isSubdomainMode: boolean;
  handleSetStep: (value: DomainStepView) => void;
}

export default function DomainConnectView({
  userDomain,
  isSubdomainMode,
  handleSetStep,
}: IDomainConnectViewProps) {
  const handleVerify = async () => {
    handleSetStep(DomainStepView.Verifying);
  };

  const handleBack = async () => {
    handleSetStep(DomainStepView.AddDomain);
  };

  return (
    <div className="mt-4 mt-md-0">
      <DomainConnectInfo
        userDomain={userDomain}
        handleBack={handleBack}
        handleVerify={handleVerify}
        isSubdomainMode={isSubdomainMode}
      />
    </div>
  );
}
